/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const PROPERTY_MANAGEMENT_CATEGORIES: SupportCategory[] = [
  { id: 'pm-landscaping', label: 'Landscaping', departmentId: 'Property Management' },
  { id: 'pm-electrician', label: 'Electrician', departmentId: 'Property Management' },
  { id: 'pm-ac', label: 'HVAC', departmentId: 'Property Management' },
  { id: 'pm-plumbin', label: 'Plumbing', departmentId: 'Property Management' },
  { id: 'pm-maintenance', label: 'Maintenance', departmentId: 'Property Management' },
  // { id: 'pm-storage', label: 'Storage', departmentId: 'Property Management' },
];

export const PROPERTY_MANAGEMENT_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'pm-landscaping-landscaping', label: 'Landscaping', categoryId: 'pm-landscaping' },
  { id: 'pm-electrician-electrician', label: 'Electrician', categoryId: 'pm-electrician' },
  { id: 'pm-ac-ac', label: 'HVAC', categoryId: 'pm-ac' },
  { id: 'pm-plumbin-plumbin', label: 'Plumbing', categoryId: 'pm-plumbin' },
  { id: 'pm-maintenance-painting', label: 'Painting', categoryId: 'pm-maintenance' },
  { id: 'pm-maintenance-general', label: 'General Issues', categoryId: 'pm-maintenance' },
  // { id: 'pm-storage-storage', label: 'Storage', categoryId: 'pm-storage' },
];

const LANDSCAPING_QUESTIONS: SupportSubcategoryQuestion[] = [
  { id: 'pm-landscape-1', subcategoryId: 'pm-landscaping-landscaping', type: 'text', label: 'Subject', required: true },
  {
    id: 'pm-landscape-2',
    subcategoryId: 'pm-landscaping-landscaping',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'pm-landscape-3',
    subcategoryId: 'pm-landscaping-landscaping',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
];

const ELECTRICIAN_AC_PLUMBIN_QUESTIONS: SupportSubcategoryQuestion[] = [
  { id: 'pm-elec-1', subcategoryId: 'pm-electrician-electrician', type: 'text', label: 'Subject', required: true },
  {
    id: 'pm-elec-2',
    subcategoryId: 'pm-electrician-electrician',
    type: 'text',
    label: 'Location of request',
    required: true,
  },
  {
    id: 'pm-elec-3',
    subcategoryId: 'pm-electrician-electrician',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'pm-elec-4',
    subcategoryId: 'pm-electrician-electrician',
    type: 'date',
    label: 'Date needed completed by',
    required: true,
  },
  {
    id: 'pm-elec-5',
    subcategoryId: 'pm-electrician-electrician',
    type: 'file',
    label: 'Select A File',
    required: false,
  },
  { id: 'pm-ac-1', subcategoryId: 'pm-ac-ac', type: 'text', label: 'Subject', required: true },
  { id: 'pm-ac-3', subcategoryId: 'pm-ac-ac', type: 'textarea', label: 'Description', required: true },
  { id: 'pm-ac-4', subcategoryId: 'pm-ac-ac', type: 'date', label: 'Date needed completed by', required: true },
  { id: 'pm-ac-5', subcategoryId: 'pm-ac-ac', type: 'file', label: 'Select A File', required: false },
  { id: 'pm-plumb-1', subcategoryId: 'pm-plumbin-plumbin', type: 'text', label: 'Subject', required: true },
  { id: 'pm-plumb-2', subcategoryId: 'pm-plumbin-plumbin', type: 'text', label: 'Location of request', required: true },
  {
    id: 'pm-plumb-3',
    subcategoryId: 'pm-plumbin-plumbin',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'pm-plumb-4',
    subcategoryId: 'pm-plumbin-plumbin',
    type: 'date',
    label: 'Date needed completed by',
    required: true,
  },
  { id: 'pm-plumb-5', subcategoryId: 'pm-plumbin-plumbin', type: 'file', label: 'Select A File', required: false },
];

export const PROPERTY_MANAGEMENT_QUESTIONS: SupportSubcategoryQuestion[] = [
  ...LANDSCAPING_QUESTIONS,
  ...ELECTRICIAN_AC_PLUMBIN_QUESTIONS,
  {
    id: 'pm-paint-1',
    subcategoryId: 'pm-maintenance-painting',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'pm-paint-2',
    subcategoryId: 'pm-maintenance-painting',
    type: 'text',
    label: 'Location of request',
    required: true,
  },
  {
    id: 'pm-paint-3',
    subcategoryId: 'pm-maintenance-painting',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'pm-paint-4',
    subcategoryId: 'pm-maintenance-painting',
    type: 'file',
    label: 'Upload photos of walls/ area',
    required: false,
  },
  {
    id: 'pm-general-1',
    subcategoryId: 'pm-maintenance-general',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'pm-general-2',
    subcategoryId: 'pm-maintenance-general',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'pm-general-3',
    subcategoryId: 'pm-maintenance-general',
    type: 'date',
    label: 'Date needed completed by',
    required: true,
  },
  {
    id: 'pm-general-4',
    subcategoryId: 'pm-maintenance-general',
    type: 'text',
    label: 'Link of item(s) needed to complete this project',
    required: false,
  },
  {
    id: 'pm-general-5',
    subcategoryId: 'pm-maintenance-general',
    type: 'file',
    label: 'Upload photos of issue',
    required: false,
  },
  {
    id: 'pm-storage-1',
    subcategoryId: 'pm-storage-storage',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'pm-storage-2',
    subcategoryId: 'pm-storage-storage',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'pm-storage-3',
    subcategoryId: 'pm-storage-storage',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'pm-storage-4',
    subcategoryId: 'pm-storage-storage',
    type: 'file',
    label: 'Upload photos of issue',
    required: false,
  },
];
